import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { WORKSPACE_OPTION_FRAGMENT } from './fragment'
import { Data } from './types'

export const GET_WORKSPACES_FOR_SELECT: TypedDocumentNode<Data> = gql`
  ${WORKSPACE_OPTION_FRAGMENT}

  query getWorkspacesForSelect($terms: [String!]) {
    workspaces(terms: $terms) {
      nodes {
        ...WorkspaceOptionFragment
      }
    }
  }
`
